import { fetchFactory, urlUtils } from 'isotope-client'
import { ScheduledTaskApi, SchedulerFilter, ScheduleViewInfosApi, UnscheduledTaskApi } from './schedule.types'

type ApiPage<T> = {
	content: T[]
	totalElements: string
}

type ScheduledTaskResponse = {
	viewInfos: ScheduleViewInfosApi
	taches: ScheduledTaskApi[]
}

export const getCurrentSchedule = (filters: SchedulerFilter, ressourcesToDisplay: string) => fetchFactory<ScheduledTaskResponse>(`/schedule/current-scheduled/${ressourcesToDisplay}`, {
	method: 'POST',
	body: JSON.stringify(filters)
})

export const getCurrentUnscheduledTasks = (pageOffset: number, pageSize: number, query?: string) => fetchFactory<ApiPage<UnscheduledTaskApi>>(
	urlUtils.buildUrlWithParams(
		'/schedule/current-unscheduled',
		{
			pageOffset,
			pageSize,
			query
		}
	)
)

export const getSolutionSchedule = (filters: SchedulerFilter, ressourcesToDisplay: string) => fetchFactory<ScheduledTaskResponse>(`/schedule/solution-scheduled/${ressourcesToDisplay}`, {
	method: 'POST',
	body: JSON.stringify(filters)
})

export const getSolutionUnscheduledTasks = (pageOffset: number, pageSize: number, query?: string) => fetchFactory<ApiPage<UnscheduledTaskApi>>(
	urlUtils.buildUrlWithParams(
		'/schedule/solution-unscheduled',
		{
			pageOffset,
			pageSize,
			query
		}
	)
)